const formatNumber = (number) => Number(number).toLocaleString('nl-NL').replace(/,/g, '.');
const formatSubNumber = (number) => Number(number).toLocaleString('nl-NL');

const formatDuration = (durationTime, numOfMedia, mediatype) => {
  if (typeof durationTime === 'number' && mediatype !== 'FOTO') {
    const date = new Date(null);
    date.setSeconds(durationTime);
    return date.toISOString().substr(14, 5);
  }
  return numOfMedia > 1 ? numOfMedia : '';
};

const formatDateItem = (date, showTime = false) => {
  const d = new Date(date);
  const today = new Date(Date.now());
  const newDate = new Date(Date.now());
  const yesterday = new Date(newDate.setDate(newDate.getDate() - 1));
  const months = [
    'jan.',
    'feb.',
    'maa.',
    'apr.',
    'mei',
    'jun.',
    'jul.',
    'aug.',
    'sep.',
    'okt.',
    'nov.',
    'dec.',
  ];
  const fullDate = (date, minusDay) => {
    const setDate = minusDay ? yesterday : date;
    return `${setDate.getDate()}${setDate.getMonth()}${setDate.getFullYear()}`;
  };

  const fullDateString = (date) =>
    `${date.getDate()} ${months[date.getMonth()]} '${String(date.getFullYear()).slice(-2)}`;
  const fullTimeString = (date) =>
    `${('0' + date.getHours()).slice(-2)}:${('0' + date.getMinutes()).slice(-2)}`;

  let returnDate = '';
  if (fullDate(today) === fullDate(d)) {
    returnDate = `vandaag @ ${fullTimeString(d)}`;
  } else if (fullDate(today, true) === fullDate(d)) {
    returnDate = `gister @ ${fullTimeString(d)}`;
  } else if (showTime) {
    returnDate = `${fullDateString(d)} @ ${fullTimeString(d)}`;
  } else {
    returnDate = fullDateString(d);
  }
  return returnDate;
};

const formatDate = (date, short = false, fullYear = false) => {
  const newDate = new Date(date);
  return newDate.toLocaleDateString(
    'nl-nl',
    short
      ? {
          year: fullYear ? 'numeric' : '2-digit',
          month: '2-digit',
          day: '2-digit',
        }
      : { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' },
  );
};

const formatTime = (date) => {
  const newDate = new Date(date);
  return newDate.toLocaleTimeString('nl-nl', {
    hour: '2-digit',
    minute: '2-digit',
  });
};

const capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const strippedContent = (content) => content.replace(/<[^>]*>?/gm, '').replace(/  +/g, ' ');

const pluralize = (count, noun, suffix = 's') => `${count} ${noun}${count !== 1 ? suffix : ''}`;

const urlShortner = (content, maxNumOfChars) => {
  const stripped = strippedContent(content);
  return stripped
    .replace(/(https?:\/\/)|(www\.)/g, '')
    .substring(0, maxNumOfChars)
    .concat(stripped.length > maxNumOfChars ? '...' : '');
};

const replaceStringURLs = (content) => {
  if (!content) {
    return;
  }

  const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;

  return content.replace(urlRegex, function (url) {
    const multipleUrls = url.split('<br>');
    const urlList = [
      ...multipleUrls.map((url) => {
        if (!url.startsWith('http') && !url.startsWith('www')) {
          return url;
        } else {
          const hasSuffix = url.endsWith(',') || url.endsWith('.');
          const suffix = hasSuffix ? url.slice(-1) : '';

          let hyperlink = hasSuffix ? url.substring(0, url.length - 1) : url;

          if (!hyperlink.match('^https?://')) {
            hyperlink = 'http://' + hyperlink;
          }
          return (
            '<a href="' +
            hyperlink +
            '" target="_blank" rel="noopener noreferrer" style="word-break: break-all;">' +
            urlShortner(hyperlink, 25) +
            '</a>' +
            suffix
          );
        }
      }),
    ];
    return urlList.join('<br>');
  });
};

const mutateDate = (date, type, offset) => {
  switch (type) {
    case 'day':
    case 'dag':
      date.setDate(date.getDate() + offset);
      break;
    case 'week':
      date.setDate(date.getDate() + offset * 7);
      break;
    case 'month':
    case 'maand':
      date.setMonth(date.getMonth() + offset);
      break;
  }
  return date;
};

const addLeadingZero = (input) => (input.length > 1 ? input : '0' + input);

const formatDatePagination = (date, type) => {
  const dateInput = new Date(date);
  const firstDayOfYear = new Date(dateInput.getFullYear(), 0, 1);
  const daysSinceFirstDay = Math.ceil((dateInput - firstDayOfYear) / 86400000);
  const currentWeekNumber = Math.ceil(daysSinceFirstDay / 7);
  const isFirstWeekOfYear = currentWeekNumber === 0;

  const year = date.getFullYear();
  let month = (1 + date.getMonth()).toString();
  month = addLeadingZero(month);
  let week = isFirstWeekOfYear ? '52' : currentWeekNumber.toString();
  week = addLeadingZero(week);
  let day = date.getDate().toString();
  day = addLeadingZero(day);

  switch (type) {
    case 'day':
    case 'dag':
      return `${year}-${month}-${day}`;
    case 'week':
      return `${isFirstWeekOfYear ? year - 1 : year}${week}`;
    case 'month':
    case 'maand':
      return `${year}${month}`;
  }
};

const openExternalHref = (url) => {
  window.open(url, '_blank', 'noopener, noreferrer');
};

const pageMetaTitle = (title) => {
  return `DUMPERT${title ? ` - ${title}` : ''}`;
};

const timeStampLink = (content, id, item) => {
  if (!content) {
    return;
  }
  const urlRegex = /(\d+\|)?(0?[0-9]|[0-5][0-9]):[0-5][0-9](?![\d:])/g;
  const multipleMedia = Boolean(item && item.media && item.media.length > 1);

  return content.replace(urlRegex, (time) => {
    let timestamp = time;
    let playerId = `id=${id}`;
    let videoTitle = '';

    if (time.includes('|')) {
      const [pl, tm] = time.split('|');
      timestamp = tm;
      const mediaIndex = parseInt(pl) - 1;
      videoTitle = `video ${mediaIndex + 1} | `;
      const isVideoIndex =
        multipleMedia &&
        item.media.length > mediaIndex &&
        item.media[mediaIndex].mediatype === 'VIDEO';
      if (multipleMedia && isVideoIndex && mediaIndex > 0) {
        playerId += `-${mediaIndex}`;
      } else if (!isVideoIndex) {
        return time;
      }
    }
    const createTimeStamp = (time) =>
      addLeadingZero(time.split(':')[0]) + ':' + addLeadingZero(time.split(':')[1]);
    const createTimeUrl = (time) =>
      '#time=' +
      createTimeStamp(time).split(':')[0] +
      'm' +
      createTimeStamp(time).split(':')[1] +
      's';

    return (
      '<a href="' +
      createTimeUrl(timestamp) +
      playerId +
      '" style="word-break: break-all;">' +
      videoTitle +
      createTimeStamp(timestamp) +
      '</a>'
    );
  });
};

const openWindow = (url) => window.open(url, 'Dumpert admin', 'width=480,height=640,location=no');

const currentDevice = (userAgent) => {
  if (userAgent.isMobile) {
    return 'MOBILE';
  }
  if (userAgent.isTablet) {
    return 'TABLET';
  }
  if (userAgent.isDesktop) {
    return 'DESKTOP';
  }
};

const currentDeviceWidth = (width) => {
  if (width <= 640) {
    return 'MOBILE';
  }
  if (width < 1024) {
    return 'TABLET';
  }
  if (width >= 1024) {
    return 'DESKTOP';
  }
};

const scrollToTop = () => window.scrollTo(0, 0);

const scrollToLocation = (location) =>
  document.getElementById(location).scrollIntoView({
    behavior: 'smooth',
    block: location === 'form' ? 'end' : 'center',
  });

const replaceNewlinesWithBreaks = (input) => {
  const collapsedContent = input.replace(/\n{2,}/g, '\n');
  const lines = collapsedContent.split('\n');
  const formattedLines = lines.map((line, index) => (index === 0 ? line : `<br>${line}`));

  return formattedLines.join('');
};

const decodeURIComponentSafely = (uri) => {
  try {
    return decodeURIComponent(uri);
  } catch (e) {
    return '';
  }
};

const encodeProfileUrl = (username) => {
  return encodeURIComponent(username.toLowerCase());
};

function convertToDate(birthdate) {
  // Ensure the birthdate is in the correct format 'yyyymmdd'
  if (!/^\d{8}$/.test(birthdate)) {
    throw new Error('Invalid date format. Please use "yyyymmdd".');
  }

  // Extract year, month, and day from the birthdate string
  const year = parseInt(birthdate.substring(0, 4), 10);
  const month = parseInt(birthdate.substring(4, 6), 10) - 1; // Month is 0-indexed
  const day = parseInt(birthdate.substring(6, 8), 10);

  return new Date(year, month, day);
}

export {
  addLeadingZero,
  currentDevice,
  currentDeviceWidth,
  decodeURIComponentSafely,
  encodeProfileUrl,
  formatNumber,
  formatDuration,
  formatDateItem,
  formatDate,
  formatTime,
  capitalize,
  strippedContent,
  pluralize,
  replaceStringURLs,
  mutateDate,
  formatDatePagination,
  openExternalHref,
  pageMetaTitle,
  timeStampLink,
  urlShortner,
  openWindow,
  scrollToTop,
  scrollToLocation,
  replaceNewlinesWithBreaks,
  formatSubNumber,
  convertToDate,
};
